import React from "react";
import styled from "styled-components";
import { AppText, FlexDiv } from "../../../ui";
import FiveStars from "../../../ui/FiveStars";
import theme from "../../../../util/theme";
import { mobileSize } from "../../../../util/variables";
import { AwardsCompact } from "../../index/AwardsCompact";

const JoinMillionsQuestion: React.FC = () => {
  return (
    <FlexDiv
      direction="column"
      justify="center"
      mobileJustify="space-around"
      align="center"
      gap={64}
      mobileGap={48}
      style={{ height: "80%" }}
    >
      <FlexDiv direction="column" align="center" gap={14} mobileGap={8}>
        <AppText noMargin fontWeight={500} fontSize={48} mobileFontSize={36} style={{ maxWidth: 468 }}>
          Join Millions
        </AppText>
        <AppText noMargin fontWeight={500} fontSize={18} style={{ maxWidth: 468 }}>
          That Choose Imprint to Grow
        </AppText>
      </FlexDiv>
      <Box>
        <AppText noMargin textAlign="center" fontSize={32} mobileFontSize={24}>
          “Imprint packs <b>daily growth</b> into a <b>stunning visual</b> learning format.”
        </AppText>
        <FiveStars width={34} height={32} mobileWidth={23} mobileHeight={22} color={theme.PRIMARY_COLOR} />
      </Box>
      <AwardsCompact />
    </FlexDiv>
  );
};

const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  max-width: 468px;
  width: 100%;
  max-height: 348px;
  height: 348px;
  border-radius: 32px;
  background-color: #EDF1DD;
  padding: 48px 40px;

  @media ${mobileSize} {
    max-height: 232px;
    padding: 32px 24px;
    border-radius: 24px;
  }
`;

export default JoinMillionsQuestion;
